import useSWR from 'swr';

import axiosInstance from 'apis/axiosInstance';
import { loadSelectedClinicId } from 'utils/storage';
import { IClinicApiKey } from 'interfaces/clinicApiKeys';

const useClinicApiKeys = () => {
  const clinicId = loadSelectedClinicId();

  const url = '/clinic-api-keys';

  const { data, error, mutate } = useSWR<IClinicApiKey[]>(
    clinicId ? [url, clinicId] : null,
    async (...resource) => {
      const [url] = resource;
      const response = await axiosInstance.get<IClinicApiKey[]>(url);
      return response.data;
    }
  );

  return {
    data,
    error,
    isLoading: !data && !error,
    mutate,
  };
};

export default useClinicApiKeys;
